/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Presentation_Templates_My_HintInputs */



/**
* | output |
* | --- |
* | "Reusable themes for your presentations." |
*
* @param {Presentation_Templates_My_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const presentation_templates_my_hint = /** @type {((inputs?: Presentation_Templates_My_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Presentation_Templates_My_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wiederverwendbare Designs für Ihre Präsentationen.")
	return /** @type {LocalizedString} */ ("Reusable themes for your presentations.")
});